import { Section, SectionParagraph, SectionTitle } from '@/components/shared/Content';
import { Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';

const CardTitle = styled.h3`
  ${font('main', { fontWeight: 'bold', fontSize: '2rem' })};
  margin-top: 0px;
  margin-bottom: 8px;
  ${MEDIA_QUERIES.tabletAndDesktop`
    ${font('main', { fontWeight: 'bold', fontSize: '2.4rem' })};
    margin-top: 24px;
    margin-bottom: 12px;
  `}
`;

const CardImage = styled(Image)`
  height: 100px;
  width: 100px;
  margin: 0 20px 0 auto;
  ${MEDIA_QUERIES.tabletAndDesktop`
    height: 175px;
    width: 175px;
    margin: 0 auto;
  `}
`;

const CardContent = styled(SectionParagraph)`
  text-wrap: balance;
  text-align: left;
  font-size: 1.6rem;
  ${MEDIA_QUERIES.tabletAndDesktop`
    font-size: 1.8rem;
    text-align: center;
  `}
`;

const CardWrapper = styled(Flex)`
  text-align: left;
  ${MEDIA_QUERIES.tabletAndDesktop`
    max-width: 280px;
    text-align: center;
  `}
`;

const CardsContainer = styled(Flex)`
  gap: 40px;
  margin-top: 50px;
  ${MEDIA_QUERIES.tabletAndDesktop`
    gap: 70px;
    margin-top: 80px;
  `}
`;

interface CardProps {
  title: string;
  content: string;
  image: StaticImageData;
}

const Card: React.FC<CardProps> = ({ title, content, image }) => {
  return (
    <CardWrapper flexDirection={['row', 'column']} justifyContent="center" alignItems="center">
      <CardImage src={image} alt="" />
      <div>
        <CardTitle>{title}</CardTitle>
        <CardContent>{content}</CardContent>
      </div>
    </CardWrapper>
  );
};

export interface HowToCompareProps {
  title: string;
  subtitle: string;
  cards: CardProps[];
}

export const HowToCompare: React.FC<HowToCompareProps> = ({ title, subtitle, cards }) => {
  return (
    <Section darkBackground py={[40, 70]} px="20px">
      <Flex flexDirection="column" gap="20px">
        <SectionTitle>{title}</SectionTitle>
        <SectionParagraph>{subtitle}</SectionParagraph>
      </Flex>

      <CardsContainer alignItems="start" flexDirection={['column', 'row']}>
        {cards.map(card => (
          <Card {...card} key={card.title} />
        ))}
      </CardsContainer>
    </Section>
  );
};
